var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 230,
    viewBox: "0 0 230 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115 0C51.4876 0 0 51.4876 0 115C0 178.512 51.4876 230 115 230C178.512 230 230 178.512 230 115C230 51.4876 178.512 0 115 0Z",
    fill: "url(#paint0_linear_12_146)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2118 98.7809C51.4216 111.075 52.4628 123.616 56.2559 135.447C60.049 147.278 66.4939 158.087 75.099 167.048L112.162 159.309C98.7364 155.172 87.0741 146.675 79.0209 135.163C70.9677 123.652 66.9835 109.783 67.6989 95.7525",
    fill: "url(#paint1_linear_12_146)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2118 98.7809C51.4216 111.075 52.4628 123.616 56.2559 135.447C60.049 147.278 66.4939 158.087 75.099 167.048L112.162 159.309C98.7364 155.172 87.0741 146.675 79.0209 135.163C70.9677 123.652 66.9835 109.783 67.6989 95.7525",
    stroke: "white",
    strokeWidth: 0.782526,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2118 98.7808C53.7427 95.1757 54.5165 91.6106 55.5281 88.1098L53.2118 98.7808Z",
    fill: "url(#paint2_linear_12_146)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2118 98.7808C53.7427 95.1757 54.5165 91.6106 55.5281 88.1098",
    stroke: "white",
    strokeWidth: 0.782526,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.699 95.7525C67.8818 92.2233 68.3608 88.7157 69.131 85.2667L55.5202 88.1098C54.5114 91.6108 53.7401 95.1759 53.2118 98.7809",
    fill: "url(#paint3_linear_12_146)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.699 95.7525C67.8818 92.2233 68.3608 88.7157 69.131 85.2667L55.5202 88.1098C54.5114 91.6108 53.7401 95.1759 53.2118 98.7809",
    stroke: "white",
    strokeWidth: 0.782526,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5036 96.5846C60.8254 96.5846 64.3289 93.0811 64.3289 88.7593C64.3289 84.4375 60.8254 80.9341 56.5036 80.9341C52.1818 80.9341 48.6783 84.4375 48.6783 88.7593C48.6783 93.0811 52.1818 96.5846 56.5036 96.5846Z",
    fill: "#8EC55E",
    stroke: "white",
    strokeWidth: 0.782526,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5764 97.6827C71.8981 97.6827 75.4016 94.1792 75.4016 89.8574C75.4016 85.5357 71.8981 82.0322 67.5764 82.0322C63.2546 82.0322 59.7511 85.5357 59.7511 89.8574C59.7511 94.1792 63.2546 97.6827 67.5764 97.6827Z",
    fill: "#8EC55E",
    stroke: "white",
    strokeWidth: 0.782526,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2507 70.2969C90.8154 65.8745 84.3585 62.8846 77.4701 61.6005C77.7492 60.9692 78.0387 60.3406 78.3491 59.725C80.9385 54.553 84.5555 49.9635 88.9789 46.237C93.4024 42.5105 98.5394 39.7253 104.076 38.0516C95.2304 36.1372 86.0048 37.0953 77.7415 40.7864C69.4781 44.4776 62.6082 50.7093 58.1312 58.5747C48.1957 56.2882 37.7636 57.8239 28.9085 62.8766C20.0534 67.9293 13.4237 76.1289 10.3372 85.8457C17.9561 78.5669 28.1016 74.5275 38.6385 74.5773C38.0768 75.1894 37.5299 75.8233 36.9978 76.4789C32.1742 82.4219 29.0615 89.5672 27.9944 97.1466C26.9272 104.726 27.946 112.453 30.9411 119.497C31.7925 110.829 35.3098 102.638 41.0088 96.0514C46.7077 89.4649 54.3081 84.8067 62.7638 82.7182C69.4902 87.7704 74.4802 94.7881 77.0434 102.801C79.6066 110.813 79.6162 119.424 77.071 127.442C82.3976 122.344 86.2345 115.89 88.1692 108.775C90.104 101.66 90.0636 94.1525 88.0524 87.0586C87.7498 85.9944 87.409 84.951 87.0299 83.9285C92.5107 85.8919 97.5263 88.9675 101.762 92.9621C105.997 96.9567 109.36 101.784 111.64 107.141C112.326 100.206 111.279 93.2085 108.593 86.7778C105.907 80.3471 101.666 74.684 96.2507 70.2969Z",
    fill: "url(#paint4_linear_12_146)",
    stroke: "white",
    strokeWidth: 0.782526,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M132.583 136.866C132.583 134.61 131.926 132.403 130.692 130.515C129.458 128.626 127.701 127.138 125.634 126.232C124.164 125.591 122.577 125.259 120.973 125.256C120.378 125.256 119.783 125.302 119.194 125.392C116.296 125.846 113.676 127.376 111.857 129.678C111.742 129.821 111.632 129.97 111.526 130.121C110.869 130.903 109.989 131.464 109.003 131.728C108.017 131.992 106.973 131.946 106.015 131.596C105.056 131.246 104.228 130.61 103.643 129.774C103.058 128.937 102.745 127.941 102.746 126.92C102.744 124.708 103.48 122.558 104.836 120.81C106.193 119.063 108.093 117.817 110.237 117.269C110.956 117.089 111.692 116.987 112.433 116.967H112.955C114.07 116.982 115.183 117.089 116.281 117.288C120.859 118.128 124.998 120.548 127.977 124.125C130.955 127.703 132.585 132.211 132.583 136.866Z",
    fill: "url(#paint5_linear_12_146)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M125.634 126.232C127.701 127.138 129.458 128.626 130.692 130.515C131.926 132.403 132.583 134.61 132.583 136.866C132.583 140.479 131.6 144.023 129.739 147.119C127.878 150.214 125.208 152.745 122.018 154.439C118.828 156.133 115.236 156.926 111.629 156.733C108.022 156.541 104.535 155.37 101.543 153.346C101.282 153.169 101.021 152.989 100.776 152.801C101.334 152.658 101.885 152.488 102.422 152.298C105.953 153.556 109.78 153.732 113.412 152.803C117.043 151.875 120.315 149.883 122.809 147.083C125.302 144.284 126.903 140.804 127.407 137.09C127.911 133.375 127.294 129.594 125.637 126.232H125.634Z",
    fill: "url(#paint6_linear_12_146)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M125.634 126.232C127.162 129.332 127.807 132.792 127.499 136.234C127.191 139.677 125.942 142.968 123.888 145.747C121.834 148.526 119.055 150.687 115.855 151.992C112.654 153.297 109.157 153.696 105.745 153.146C110.162 152.433 114.18 150.171 117.08 146.765C119.98 143.359 121.573 139.031 121.573 134.558C121.573 133.629 121.505 132.701 121.37 131.783C121.037 129.538 120.3 127.373 119.194 125.392C119.783 125.302 120.378 125.256 120.973 125.256C122.577 125.259 124.164 125.591 125.634 126.232Z",
    fill: "url(#paint7_linear_12_146)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M121.37 131.783C121.505 132.701 121.573 133.629 121.573 134.558C121.573 139.031 119.981 143.359 117.08 146.765C114.18 150.171 110.162 152.433 105.745 153.146C104.616 152.965 103.505 152.681 102.427 152.298C105.752 151.112 108.677 149.016 110.868 146.249C113.059 143.482 114.43 140.155 114.823 136.647C114.898 135.954 114.936 135.258 114.937 134.561C114.941 132.254 114.52 129.967 113.696 127.813C115.286 126.533 117.187 125.698 119.205 125.392C120.307 127.374 121.041 129.539 121.37 131.783Z",
    fill: "url(#paint8_linear_12_146)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 130.121C111.633 129.97 111.742 129.821 111.857 129.678C111.755 129.831 111.644 129.979 111.526 130.121Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 130.121C110.869 130.903 109.989 131.464 109.003 131.728C108.017 131.992 106.973 131.946 106.015 131.596C105.056 131.246 104.228 130.61 103.643 129.774C103.058 128.937 102.745 127.941 102.746 126.92",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 130.121C111.644 129.979 111.755 129.831 111.857 129.678",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M106.684 118.986C107.739 118.186 108.944 117.606 110.227 117.28",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M110.237 117.28C110.956 117.099 111.692 116.998 112.433 116.977",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M106.684 118.986C105.456 119.912 104.46 121.111 103.775 122.488C103.09 123.865 102.734 125.382 102.735 126.92",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M116.276 117.298C120.852 118.137 124.99 120.554 127.97 124.128C130.949 127.703 132.582 132.208 132.583 136.861",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M116.276 117.298C115.176 117.099 114.062 116.992 112.945 116.977",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M100.781 152.801C101.042 152.989 101.288 153.169 101.548 153.346",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M132.583 136.866C132.584 140.479 131.6 144.023 129.739 147.118C127.878 150.214 125.209 152.745 122.018 154.439C118.828 156.133 115.236 156.926 111.629 156.733C108.022 156.541 104.535 155.37 101.543 153.346",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M112.423 116.977H112.945",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M122.515 125.361C122.004 125.292 121.489 125.257 120.973 125.256C120.378 125.256 119.783 125.302 119.194 125.392",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M122.515 125.361C123.594 125.501 124.648 125.795 125.645 126.232",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M111.857 129.678C112.399 128.993 113.015 128.37 113.696 127.823",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M111.526 130.121C111.633 129.97 111.742 129.821 111.857 129.678",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M119.205 125.392C117.187 125.698 115.286 126.533 113.696 127.813",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M125.635 126.232C127.701 127.138 129.458 128.626 130.692 130.515C131.926 132.403 132.583 134.61 132.583 136.866",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M114.823 136.637C114.898 135.944 114.936 135.247 114.937 134.55C114.94 132.247 114.519 129.963 113.696 127.813",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M102.427 152.298C101.89 152.488 101.34 152.658 100.781 152.801",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M112.162 144.413C109.912 148.07 106.482 150.852 102.438 152.298",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M114.823 136.637C114.523 139.394 113.614 142.05 112.162 144.413",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M121.37 131.783C121.505 132.701 121.573 133.629 121.573 134.558C121.578 139.39 119.721 144.037 116.388 147.535",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M121.37 131.783C121.037 129.538 120.3 127.373 119.194 125.392",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M116.388 147.535C113.551 150.521 109.812 152.493 105.745 153.145",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M125.634 126.232C127.438 129.893 128.003 134.04 127.246 138.05C126.488 142.06 124.449 145.715 121.435 148.466",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M102.427 152.298C103.505 152.681 104.616 152.965 105.745 153.146",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M121.435 148.466C119.341 150.377 116.842 151.79 114.125 152.6C111.409 153.41 108.544 153.597 105.745 153.146",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M185.952 139.029C187.029 134.827 187.267 130.454 186.654 126.161C186.04 121.867 184.587 117.736 182.377 114.004C180.166 110.272 177.242 107.012 173.772 104.41C170.301 101.808 166.352 99.9159 162.15 98.8409C160.508 98.4207 158.836 98.1251 157.15 97.9566C148.841 97.1577 140.538 99.53 133.906 104.598C133.489 104.916 133.076 105.245 132.675 105.584C130.315 107.273 127.493 108.196 124.591 108.227C121.689 108.258 118.847 107.396 116.452 105.757C114.057 104.117 112.225 101.781 111.203 99.0648C110.181 96.3484 110.02 93.3834 110.741 90.5722C112.566 83.4226 117.114 77.2698 123.413 73.4271C129.713 69.5844 137.265 68.3563 144.457 70.0048C144.694 70.0596 144.932 70.1196 145.169 70.1795C145.406 70.2395 145.639 70.3021 145.873 70.37C148.94 71.1949 151.933 72.2751 154.82 73.5992C179.199 84.7893 192.841 112.126 185.952 139.029Z",
    fill: "url(#paint9_linear_12_146)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M174.308 104.817C179.363 108.771 183.156 114.113 185.224 120.189C187.292 126.265 187.545 132.812 185.952 139.029C178.199 169.307 147.376 187.566 117.095 179.814C106.142 177.028 96.2808 171.011 88.7932 162.546C88.1985 161.877 87.622 161.194 87.0638 160.499C88.7045 160.499 90.3374 160.423 91.952 160.277C100.796 166.229 111.215 169.408 121.876 169.406C132.537 169.405 142.955 166.223 151.798 160.268C160.641 154.313 167.506 145.856 171.516 135.978C175.526 126.1 176.498 115.25 174.308 104.817Z",
    fill: "url(#paint10_linear_12_146)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M174.308 104.817C176.323 114.438 175.654 124.428 172.373 133.695C169.092 142.961 163.325 151.147 155.704 157.356C148.083 163.565 138.901 167.558 129.163 168.898C119.424 170.239 109.505 168.875 100.489 164.956C113.165 166.109 125.838 162.711 136.236 155.371C146.635 148.03 154.08 137.227 157.238 124.896C157.893 122.341 158.36 119.741 158.636 117.118C159.305 110.698 158.801 104.21 157.149 97.9697C158.836 98.1382 160.508 98.4338 162.15 98.8539C166.571 99.9858 170.711 102.02 174.308 104.83V104.817Z",
    fill: "url(#paint11_linear_12_146)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M158.636 117.118C158.361 119.746 157.893 122.35 157.238 124.909C154.078 137.235 146.633 148.034 136.237 155.372C125.841 162.71 113.172 166.107 100.5 164.956C97.514 163.66 94.6528 162.094 91.952 160.277C99.0623 159.62 105.97 157.549 112.269 154.185C118.568 150.822 124.131 146.235 128.633 140.692C133.135 135.149 136.484 128.763 138.483 121.908C140.483 115.053 141.093 107.868 140.278 100.774C145.555 98.3632 151.376 97.3913 157.149 97.9566C158.803 104.201 159.306 110.694 158.636 117.118Z",
    fill: "url(#paint12_linear_12_146)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M132.675 105.576C133.076 105.237 133.489 104.908 133.906 104.59C133.514 104.941 133.103 105.271 132.675 105.576Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M132.675 105.576C130.315 107.266 127.493 108.189 124.591 108.22C121.689 108.25 118.847 107.388 116.452 105.749C114.057 104.11 112.225 101.773 111.203 99.0569C110.181 96.3406 110.02 93.3756 110.741 90.5643",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M132.675 105.576C133.103 105.271 133.514 104.941 133.906 104.59",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M127.22 71.4707C130.688 70.0125 134.414 69.2648 138.176 69.2718",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M138.189 69.2822C140.296 69.2863 142.395 69.526 144.449 69.9969",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M127.22 71.4707C123.183 73.1578 119.593 75.7597 116.733 79.0714C113.873 82.3831 111.822 86.3139 110.74 90.5539",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M154.82 73.5913C179.198 84.7893 192.84 112.125 185.952 139.029",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M154.82 73.5913C151.933 72.2673 148.94 71.1871 145.873 70.3621",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0638 160.499C87.622 161.194 88.1985 161.877 88.7932 162.546",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M185.952 139.029C178.199 169.307 147.376 187.566 117.095 179.814C106.142 177.028 96.2808 171.011 88.7932 162.546",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M144.457 69.997C144.694 70.0517 144.932 70.1117 145.169 70.1717C145.406 70.2317 145.639 70.2943 145.873 70.3621",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M166.323 100.21C164.964 99.6615 163.57 99.204 162.15 98.8408C160.508 98.4207 158.836 98.1251 157.149 97.9566",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M166.323 100.21C169.189 101.362 171.877 102.913 174.308 104.817",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M133.906 104.598C135.88 103.091 138.018 101.811 140.278 100.782",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M132.675 105.576C133.076 105.237 133.489 104.908 133.906 104.59",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M157.149 97.9566C151.376 97.3913 145.555 98.3632 140.278 100.774",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M174.308 104.817C179.363 108.771 183.156 114.113 185.224 120.189C187.292 126.265 187.545 132.812 185.952 139.029",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M137.164 125.861C140.183 117.866 141.251 109.265 140.278 100.774",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M91.952 160.277C90.3374 160.423 88.7045 160.501 87.0638 160.499",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M124.32 145.412C115.534 153.902 104.117 159.146 91.952 160.28",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M137.164 125.861C134.386 133.254 129.999 139.937 124.32 145.425",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M158.636 117.118C158.361 119.746 157.893 122.35 157.238 124.909C153.842 138.226 145.442 149.72 133.786 157.001",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M158.636 117.118C159.305 110.698 158.801 104.21 157.149 97.9697",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M133.786 157.001C123.862 163.229 112.167 166.024 100.5 164.956",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M174.308 104.817C176.693 116.179 175.323 128.008 170.406 138.525C165.488 149.041 157.288 157.676 147.039 163.131",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M91.952 160.277C94.6528 162.094 97.514 163.66 100.5 164.956",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M147.039 163.131C139.917 166.912 132.035 169.04 123.978 169.356C115.921 169.672 107.896 168.168 100.5 164.956",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M222.269 137.644C222.262 132.283 220.587 127.057 217.477 122.69C214.366 118.324 209.973 115.035 204.908 113.278C199.843 111.521 194.357 111.384 189.211 112.886C184.065 114.388 179.513 117.454 176.188 121.659C175.927 121.98 175.685 122.311 175.448 122.645C173.988 124.381 172.03 125.625 169.839 126.21C167.648 126.796 165.33 126.693 163.2 125.917C161.069 125.14 159.229 123.727 157.928 121.87C156.628 120.012 155.93 117.8 155.929 115.532C155.921 109.764 158.17 104.222 162.195 100.091C166.221 95.9597 171.703 93.5675 177.469 93.4258C177.659 93.4258 177.85 93.4258 178.043 93.4258C178.236 93.4258 178.424 93.4258 178.614 93.4258C190.247 93.5625 201.357 98.2828 209.53 106.562C217.704 114.841 222.281 126.01 222.269 137.644Z",
    fill: "url(#paint13_linear_12_146)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M206.819 113.988C211.412 116.003 215.32 119.312 218.063 123.511C220.807 127.71 222.268 132.617 222.269 137.633C222.27 145.664 220.085 153.543 215.948 160.425C211.811 167.308 205.878 172.935 198.786 176.702C191.695 180.469 183.711 182.234 175.692 181.808C167.673 181.382 159.921 178.781 153.268 174.284C152.686 173.89 152.12 173.486 151.562 173.069C152.804 172.753 154.025 172.377 155.214 171.952C163.066 174.749 171.573 175.139 179.648 173.072C187.722 171.005 194.996 166.575 200.538 160.35C206.08 154.125 209.639 146.387 210.758 138.128C211.877 129.869 210.505 121.463 206.819 113.988Z",
    fill: "url(#paint14_linear_12_146)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M206.819 113.988C210.216 120.881 211.651 128.575 210.966 136.229C210.281 143.883 207.504 151.201 202.937 157.381C198.371 163.562 192.192 168.366 185.077 171.269C177.962 174.172 170.185 175.061 162.598 173.838C172.417 172.252 181.351 167.222 187.799 159.648C194.247 152.075 197.788 142.454 197.789 132.508C197.788 130.442 197.637 128.379 197.335 126.336C196.597 121.348 194.96 116.536 192.501 112.133C193.811 111.932 195.134 111.831 196.458 111.831C200.023 111.83 203.55 112.565 206.819 113.988Z",
    fill: "url(#paint15_linear_12_146)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M197.335 126.339C197.637 128.381 197.788 130.443 197.789 132.508C197.788 142.454 194.247 152.075 187.799 159.648C181.351 167.222 172.417 172.252 162.598 173.838C160.086 173.436 157.616 172.805 155.219 171.952C160.474 170.076 165.301 167.168 169.417 163.4C173.533 159.633 176.855 155.081 179.187 150.012C181.52 144.943 182.816 139.459 183.001 133.882C183.185 128.305 182.253 122.747 180.26 117.535C183.791 114.685 188.015 112.821 192.501 112.133C194.96 116.537 196.598 121.35 197.335 126.339Z",
    fill: "url(#paint16_linear_12_146)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M175.448 122.645C175.685 122.311 175.933 121.98 176.188 121.659C175.959 122.001 175.711 122.33 175.448 122.645Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M175.448 122.645C173.988 124.381 172.03 125.625 169.839 126.21C167.648 126.796 165.33 126.693 163.2 125.917C161.069 125.14 159.229 123.727 157.928 121.87C156.628 120.012 155.93 117.8 155.929 115.532",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M175.448 122.645C175.711 122.33 175.959 122.001 176.188 121.659",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M164.709 97.8888C167.055 96.1112 169.733 94.8216 172.586 94.0961",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M172.586 94.0961C174.184 93.6917 175.821 93.4668 177.469 93.4258",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M164.709 97.8888C161.979 99.9488 159.765 102.615 158.241 105.677C156.717 108.738 155.926 112.112 155.929 115.532",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M186.012 94.1378C196.189 96.0042 205.391 101.379 212.015 109.328C218.639 117.277 222.268 127.296 222.269 137.644",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M186.011 94.1378C183.57 93.6936 181.095 93.4554 178.614 93.4258",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M151.562 173.069C152.12 173.486 152.686 173.89 153.268 174.284",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M222.269 137.644C222.268 145.673 220.081 153.551 215.944 160.432C211.806 167.313 205.873 172.938 198.782 176.704C191.69 180.47 183.707 182.234 175.689 181.808C167.671 181.382 159.92 178.781 153.268 174.284",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M177.469 93.4258C177.659 93.4258 177.85 93.4258 178.043 93.4258C178.236 93.4258 178.424 93.4258 178.614 93.4258",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M199.881 112.06C198.745 111.907 197.601 111.831 196.456 111.831C195.132 111.831 193.81 111.932 192.501 112.133",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M199.881 112.06C202.273 112.376 204.609 113.029 206.819 113.998",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M176.188 121.659C177.391 120.137 178.76 118.753 180.27 117.535",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M175.448 122.645C175.685 122.311 175.933 121.98 176.188 121.659",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M192.501 112.133C188.02 112.823 183.801 114.687 180.273 117.535",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M206.819 113.988C211.412 116.003 215.32 119.312 218.063 123.511C220.807 127.71 222.268 132.617 222.269 137.633",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M182.777 137.132C182.948 135.598 183.036 134.055 183.038 132.51C183.044 127.391 182.108 122.315 180.276 117.535",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M155.219 171.952C154.025 172.377 152.804 172.753 151.567 173.069",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M176.851 154.418C171.845 162.55 164.218 168.732 155.227 171.947",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M182.777 137.132C182.107 143.262 180.083 149.167 176.851 154.418",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M197.335 126.339C197.637 128.381 197.788 130.443 197.789 132.508C197.801 143.251 193.671 153.585 186.257 161.359",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M197.335 126.339C196.598 121.35 194.96 116.537 192.501 112.133",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M186.257 161.362C179.951 168.001 171.639 172.385 162.598 173.838",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M206.819 113.988C210.827 122.127 212.084 131.348 210.4 140.264C208.716 149.179 204.182 157.306 197.481 163.423",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M155.219 171.952C157.616 172.805 160.086 173.436 162.598 173.838",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M197.481 163.433C192.824 167.68 187.268 170.821 181.229 172.622C175.189 174.424 168.821 174.84 162.598 173.838",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M146.184 160.178L168.063 163.157L164.696 175.695L143.518 172.763L146.184 160.178Z",
    fill: "#669261",
    stroke: "#009444",
    strokeWidth: 0.260842,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M145.55 158.774C151.81 161.774 153.552 178.627 154.63 197.496L74.6217 222.276L29.9499 183.557C47.0324 180.349 77.3214 179.467 122.241 176.54C144.538 172.881 154.28 167.257 145.55 158.774Z",
    fill: "url(#paint17_linear_12_146)",
    stroke: "#215A2D",
    strokeWidth: 0.260842,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M144.321 157.893C152.773 163.613 149.236 167.951 142.545 171.924C116.68 182.553 57.7426 178.76 29.9499 183.557L22.5811 172.012C60.1424 168.859 90.9843 166.057 117.301 165.796C112.819 159.536 107.016 154.004 100.429 148.925C114.645 151.575 135.7 157.825 144.321 157.893Z",
    fill: "url(#paint18_linear_12_146)",
    stroke: "#215A2D",
    strokeWidth: 0.260842,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M101.872 149.022C88.7228 153.993 53.5118 155.462 16.7148 155.592C22.469 151.027 26.8146 146.424 55.2542 142.451C67.7798 141.395 84.5128 144.859 101.872 149.022Z",
    fill: "url(#paint19_linear_12_146)",
    stroke: "#215A2D",
    strokeWidth: 0.260842,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M101.872 149.022C101.872 149.022 113.594 155.149 120.786 166.159C120.277 165.551 25.1087 171.344 25.8625 172.375L16.7148 155.592C58.0452 154.134 93.3554 152.332 101.872 149.022Z",
    fill: "url(#paint20_linear_12_146)",
    stroke: "#215A2D",
    strokeWidth: 0.260842,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M113.685 187.172C102.357 194.366 94.0883 205.658 86.5317 217.902L139.321 225.85L166.229 216.52L186.163 200.587C138.546 198.055 100.033 197.703 113.685 187.172Z",
    fill: "url(#paint21_linear_12_146)",
    stroke: "#215A2D",
    strokeWidth: 0.260842,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M142.712 179.851C105.779 183.669 97.5862 196.524 134.083 198.055C157.781 199.92 169.579 200.301 189.426 200.585L206.475 179.851H142.712Z",
    fill: "url(#paint22_linear_12_146)",
    stroke: "#215A2D",
    strokeWidth: 0.260842,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M173.027 163.6C149.762 164.044 151.982 170.544 166.722 170.943C175.68 172.143 188.685 172.769 202.552 173.29L213.476 163.151L173.027 163.6Z",
    fill: "url(#paint23_linear_12_146)",
    stroke: "#215A2D",
    strokeWidth: 0.260842,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M155.582 167.526C141.65 175.565 136.872 181.457 134.845 186.705C138.236 189.369 171.23 185.307 193.628 190.524L202.552 173.309C178.69 171.321 158.109 172.088 155.582 167.526Z",
    fill: "url(#paint24_linear_12_146)",
    stroke: "#215A2D",
    strokeWidth: 0.260842,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M192.249 126.078C193.905 126.669 195.459 127.464 196.864 128.442",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M224.585 145.289C224.581 142.538 223.613 139.856 221.815 137.615C220.017 135.374 217.478 133.686 214.551 132.784C211.623 131.882 208.452 131.812 205.478 132.583C202.503 133.354 199.873 134.927 197.951 137.086C197.8 137.25 197.66 137.42 197.523 137.592C196.679 138.482 195.547 139.121 194.281 139.421C193.015 139.722 191.675 139.669 190.444 139.27C189.212 138.872 188.149 138.147 187.397 137.194C186.645 136.24 186.242 135.105 186.241 133.941C186.237 130.981 187.537 128.136 189.863 126.016C192.19 123.896 195.358 122.668 198.691 122.596C198.801 122.596 198.911 122.596 199.023 122.596C199.134 122.596 199.243 122.596 199.353 122.596C206.077 122.666 212.498 125.088 217.222 129.337C221.946 133.586 224.592 139.318 224.585 145.289Z",
    fill: "url(#paint25_linear_12_146)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M197.523 137.592C197.66 137.42 197.803 137.25 197.951 137.086C197.818 137.261 197.675 137.43 197.523 137.592Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M197.523 137.592C196.679 138.482 195.547 139.121 194.281 139.421C193.015 139.722 191.675 139.669 190.444 139.27C189.212 138.872 188.149 138.147 187.397 137.194C186.645 136.24 186.242 135.105 186.241 133.941",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M197.523 137.592C197.675 137.43 197.818 137.261 197.951 137.086",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M191.316 124.886C192.672 123.974 194.22 123.312 195.869 122.94",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M195.869 122.94C196.792 122.732 197.739 122.617 198.691 122.596",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M191.316 124.886C189.738 125.943 188.458 127.312 187.578 128.883C186.697 130.454 186.239 132.186 186.241 133.941",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M203.629 122.961C209.511 123.919 214.829 126.678 218.658 130.757C222.487 134.836 224.584 139.979 224.585 145.289",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M203.629 122.961C202.218 122.733 200.787 122.611 199.353 122.596",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M198.691 122.596C198.801 122.596 198.911 122.596 199.023 122.596C199.135 122.596 199.243 122.596 199.353 122.596",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M211.645 132.159C210.989 132.081 210.327 132.041 209.665 132.041C208.9 132.042 208.136 132.093 207.38 132.197",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M211.645 132.159C213.028 132.321 214.378 132.656 215.655 133.154",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M197.951 137.086C198.646 136.304 199.437 135.594 200.31 134.969",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M197.523 137.592C197.66 137.42 197.803 137.25 197.951 137.086",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M207.38 132.197C204.79 132.551 202.351 133.507 200.312 134.969",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M215.655 133.148C218.31 134.183 220.568 135.881 222.154 138.036C223.74 140.191 224.585 142.709 224.585 145.284",
    stroke: "white",
    strokeWidth: 0.521684,
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M115 0C51.4876 0 0 51.4876 0 115C0 178.512 51.4876 230 115 230C178.512 230 230 178.512 230 115C230 51.4876 178.512 0 115 0ZM115 219.89C57.0774 219.89 10.1233 172.938 10.1233 115.013C10.1233 57.0879 57.0748 10.1363 115 10.1363C172.925 10.1363 219.89 57.0774 219.89 115C219.89 172.923 172.92 219.89 115 219.89Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8038 156.646C35.8788 137.031 70.8499 137.725 118.028 152.853C173.538 167.035 204.161 168.102 216.196 159.374",
    stroke: "white",
    strokeWidth: 3.91263,
    strokeMiterlimit: 10
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0259 148.064C40.189 148.064 44.3745 143.879 44.3745 138.716C44.3745 133.553 40.189 129.367 35.0259 129.367C29.8628 129.367 25.6773 133.553 25.6773 138.716C25.6773 143.879 29.8628 148.064 35.0259 148.064Z",
    fill: "#8EC55E",
    stroke: "white",
    strokeWidth: 0.782526,
    strokeMiterlimit: 10
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3973 143.322C55.5604 143.322 59.7459 139.137 59.7459 133.974C59.7459 128.811 55.5604 124.625 50.3973 124.625C45.2342 124.625 41.0487 128.811 41.0487 133.974C41.0487 139.137 45.2342 143.322 50.3973 143.322Z",
    fill: "#8EC55E",
    stroke: "white",
    strokeWidth: 0.782526,
    strokeMiterlimit: 10
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M33.766 132.085L34.1807 129.571C34.1929 129.495 34.223 129.423 34.2683 129.361C34.3136 129.299 34.373 129.248 34.4416 129.213L43.7327 124.463L34.1129 128.668C33.9931 128.721 33.8881 128.803 33.8067 128.905C33.7254 129.008 33.6702 129.129 33.646 129.258L33.1739 131.827L31.7836 129.539C31.639 129.302 31.4275 129.114 31.1758 128.997L24.9678 126.154L30.735 129.503C30.9173 129.608 31.0733 129.754 31.1915 129.928L32.7878 132.294L31.0819 132.656L31.1967 133.196L35.3362 132.317L35.2136 131.777L33.766 132.085Z",
    fill: "#603913"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2104 127.372L47.9453 128.099L48.0027 125.434L49.153 121.505L47.408 125.181V128.157L45.2169 126.349L41.2729 125.355L45.0317 126.97L47.0897 128.595L45.5429 129.487L45.8194 129.967L49.4869 127.849L49.2104 127.372Z",
    fill: "#603913"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_146",
    x1: 115,
    y1: 230,
    x2: 115,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF33B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FEE72E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FED51B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FDCA10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FDC70C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F3903F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#ED683C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E93E3A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_146",
    x1: 55.6393,
    y1: 134.681,
    x2: 104.867,
    y2: 124.397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D97E4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A5952"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12_146",
    x1: 52.1862,
    y1: 93.8909,
    x2: 56.5396,
    y2: 92.9815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D97E4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A5952"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12_146",
    x1: 52.1862,
    y1: 93.891,
    x2: 70.1512,
    y2: 90.1379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D97E4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A5952"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12_146",
    x1: 61.09,
    y1: 127.444,
    x2: 61.0904,
    y2: 37.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#257065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#257369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#257D76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#258C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#26A2AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26B5C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_12_146",
    x1: 102.746,
    y1: 126.92,
    x2: 132.583,
    y2: 126.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9EDDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_12_146",
    x1: 100.781,
    y1: 141.496,
    x2: 132.583,
    y2: 141.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85D5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D5F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_12_146",
    x1: 105.745,
    y1: 139.321,
    x2: 127.572,
    y2: 139.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85D5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29B0E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_12_146",
    x1: 102.427,
    y1: 139.269,
    x2: 121.573,
    y2: 139.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29B0E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2F80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_12_146",
    x1: 110.741,
    y1: 90.5644,
    x2: 192.971,
    y2: 111.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9EDDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_12_146",
    x1: 95.043,
    y1: 129.344,
    x2: 182.686,
    y2: 151.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85D5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D5F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_12_146",
    x1: 110.258,
    y1: 126.855,
    x2: 170.411,
    y2: 142.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85D5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29B0E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_12_146",
    x1: 101.147,
    y1: 124.369,
    x2: 153.915,
    y2: 137.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29B0E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2F80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_12_146",
    x1: 155.929,
    y1: 115.532,
    x2: 222.269,
    y2: 115.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9EDDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_12_146",
    x1: 151.562,
    y1: 147.934,
    x2: 222.269,
    y2: 147.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85D5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85D5F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_12_146",
    x1: 162.598,
    y1: 143.1,
    x2: 211.128,
    y2: 143.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85D5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29B0E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_12_146",
    x1: 155.219,
    y1: 142.986,
    x2: 197.789,
    y2: 142.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29B0E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2F80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_12_146",
    x1: 154.622,
    y1: 190.524,
    x2: 29.9499,
    y2: 190.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#257065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60A65F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_12_146",
    x1: 22.5811,
    y1: 166.24,
    x2: 149.28,
    y2: 166.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60A65F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEC97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_12_146",
    x1: 16.7148,
    y1: 148.925,
    x2: 101.872,
    y2: 148.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60A65F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEC97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_12_146",
    x1: 120.785,
    y1: 160.7,
    x2: 16.7148,
    y2: 160.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#257065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60A65F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_12_146",
    x1: 86.5317,
    y1: 206.511,
    x2: 186.163,
    y2: 206.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#257065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60A65F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_12_146",
    x1: 110.503,
    y1: 190.219,
    x2: 206.475,
    y2: 190.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEC97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60A65F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_12_146",
    x1: 155.582,
    y1: 168.227,
    x2: 213.476,
    y2: 168.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEC97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60A65F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_12_146",
    x1: 134.845,
    y1: 179.024,
    x2: 202.552,
    y2: 179.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#257065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60A65F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_12_146",
    x1: 186.241,
    y1: 133.941,
    x2: 224.585,
    y2: 133.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9EDDB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.b1dba025a648614f557f2f85778a6684.svg";
export { ForwardRef as ReactComponent };